<template>
  <div class="tramite-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">Trámites y Consultas</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Centro de Atención y Reclamos</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30">mdi-file-document-edit-outline</v-icon>
          </div>
        </div>

        <!-- Main Content -->
        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <v-tabs v-model="tab" background-color="transparent" color="primary" grow class="premium-tabs">
            <v-tab class="font-weight-bold"><v-icon left>mdi-plus-circle-outline</v-icon> Nuevo Trámite</v-tab>
            <v-tab class="font-weight-bold"><v-icon left>mdi-history</v-icon> Mis Trámites</v-tab>
          </v-tabs>

          <v-divider></v-divider>

          <div class="pa-6 content-area bg-light">
            <!-- TAB 1: NUEVO TRAMITE -->
            <div v-show="tab === 0">
              <v-alert prominent type="info" class="rounded-xl glass-card border-none mb-6">
                <strong>IMPORTANTE:</strong> Los Trámites con Asterisco (*) tienen costo.
              </v-alert>

              <v-row>
                <v-col cols="12" md="6">
                  <div class="text-subtitle-2 font-weight-bold mb-2">Curso</div>
                  <v-select
                    v-model="curso"
                    :items="cursos"
                    item-text="text"
                    item-value="value"
                    placeholder="Selecciona un curso"
                    outlined
                    rounded
                    dense
                    prepend-inner-icon="mdi-google-classroom"
                    return-object
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <div class="text-subtitle-2 font-weight-bold mb-2">Trámite</div>
                  <v-select
                    v-model="tramite"
                    :items="tramites"
                    item-text="text"
                    item-value="value"
                    placeholder="Selecciona el trámite"
                    outlined
                    rounded
                    dense
                    prepend-inner-icon="mdi-text-box-search-outline"
                    return-object
                  ></v-select>
                </v-col>

                <v-col cols="12">
                  <div class="text-subtitle-2 font-weight-bold mb-2">¿A quién va dirigido?</div>
                  <v-text-field
                    v-model="person"
                    :rules="personRules"
                    :counter="10"
                    placeholder="Escriba únicamente el nombre de la institución o empresa..."
                    outlined
                    rounded
                    dense
                    prepend-inner-icon="mdi-domain"
                    hint="Si coloca otra cosa su constancia será cancelada"
                    persistent-hint
                  ></v-text-field>
                </v-col>

                <!-- Additional fields for tramite ID 36 -->
                <v-expand-transition>
                  <v-row v-if="tramite && tramite.value === 36" class="ma-0 w-100">
                    <v-col cols="12" md="4">
                      <div class="text-subtitle-2 font-weight-bold mb-2">Materias</div>
                      <v-text-field
                        v-model="materias"
                        placeholder="Ingrese las materias"
                        outlined
                        rounded
                        dense
                        prepend-inner-icon="mdi-book-open-page-variant"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <div class="text-subtitle-2 font-weight-bold mb-2">Tipo de Examen</div>
                      <v-select
                        v-model="tipoExamen"
                        :items="tiposExamen"
                        item-text="text"
                        item-value="value"
                        placeholder="Seleccione el tipo"
                        outlined
                        rounded
                        dense
                        prepend-inner-icon="mdi-format-list-checks"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="4">
                      <div class="text-subtitle-2 font-weight-bold mb-2">Fecha del Examen</div>
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="fechaExamen"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fechaExamen"
                            placeholder="Seleccione la fecha"
                            prepend-inner-icon="mdi-calendar"
                            outlined
                            rounded
                            dense
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="fechaExamen" no-title scrollable class="rounded-xl">
                          <v-spacer></v-spacer>
                          <v-btn text color="grey" @click="menu = false">Cancelar</v-btn>
                          <v-btn text color="primary" @click="$refs.menu.save(fechaExamen)">Aceptar</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-expand-transition>
              </v-row>

              <div class="d-flex justify-end mt-6">
                <v-btn
                  color="primary"
                  rounded
                  depressed
                  large
                  class="px-8 shadow-premium"
                  @click="addTramite()"
                  :disabled="!isValidForm"
                >
                  <v-icon left>mdi-send-check</v-icon>
                  Solicitar Trámite
                </v-btn>
              </div>
            </div>

            <!-- TAB 2: MIS TRAMITES -->
            <div v-show="tab === 1">
              <div v-if="!tramitesUser || tramitesUser.length === 0" class="text-center pa-10 bg-light-gradient rounded-xl mt-4">
                <v-icon size="64" color="grey lighten-2">mdi-file-document-outline</v-icon>
                <h3 class="text-h6 grey--text text--darken-1 mt-4">No tienes trámites solicitados</h3>
                <p class="text-body-2 grey--text">Tus solicitudes aparecerán aquí una vez creadas.</p>
              </div>
              
              <v-row v-else class="mt-2">
                <v-col cols="12" md="6" lg="4" v-for="(item, index) in tramitesUser" :key="index">
                  <v-card class="rounded-xl border-light hover-card h-100 d-flex flex-column" elevation="0">
                    <div class="pa-4 flex-grow-1">
                      <div class="d-flex justify-space-between align-start mb-2">
                        <v-chip
                          small
                          :color="getEstadoColor(item.Estado)"
                          :text-color="getEstadoTextColor(item.Estado)"
                          class="font-weight-bold"
                        >
                          {{ item.Estado }}
                        </v-chip>
                        <span class="text-caption grey--text"><v-icon small color="grey" class="mr-1">mdi-clock-outline</v-icon>{{ item.FechaRegistro | formatDate }}</span>
                      </div>
                      
                      <h3 class="text-subtitle-1 font-weight-bold primary-text line-height-1 mt-3 mb-2">
                        {{ item.tramite ? item.tramite.Feriado : "Trámite Desconocido" }}
                      </h3>
                      
                      <div class="d-flex align-center mt-3">
                        <v-icon small color="grey" class="mr-2">mdi-alert-circle-outline</v-icon>
                        <span class="text-caption grey--text text--darken-2">Urgencia: <strong>{{ item.Urgencia }}</strong></span>
                      </div>
                    </div>

                    <!-- Actions Footer -->
                    <div class="px-4 py-3 bg-light border-top mt-auto">
                      <div v-if="item.Estado == 'Cancelado' && item.motivo != null">
                        <v-btn small block color="error" outlined rounded @click="motivoRechazoTramite(item.motivo)">
                          <v-icon left small>mdi-comment-alert-outline</v-icon> Motivo de Rechazo
                        </v-btn>
                      </div>
                      
                      <div v-else-if="item.tramite && tramitesEmail.includes(item.tramite.IDF) && item.Estado == 'Finalizado'">
                        <div class="d-flex align-center justify-center info--text text-caption font-weight-bold bg-info-light rounded-pill pa-2">
                          <v-icon small color="info" class="mr-1">mdi-email-check-outline</v-icon>
                          Enviado por Email
                        </div>
                      </div>
                      
                      <div v-else-if="item.url && hoy >= item.dias_expiracion">
                        <v-btn small block color="success" rounded depressed :href="item.url" target="_blank" class="shadow-premium">
                          <v-icon left small>mdi-download</v-icon> Descargar Constancia
                        </v-btn>
                      </div>
                      
                      <div v-else class="text-center text-caption grey--text py-1">
                        <v-icon small color="grey lighten-1">mdi-dots-horizontal</v-icon> Sin acciones disponibles
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </v-col>

      <!-- Modal de Rechazo -->
      <v-dialog v-model="motivoRechazo" max-width="400">
        <v-card class="rounded-xl">
          <v-card-title class="error white--text text-subtitle-1 font-weight-bold px-4 py-3">
            <v-icon color="white" class="mr-2">mdi-alert-circle</v-icon>
            Motivo del Rechazo
          </v-card-title>
          <v-card-text class="pa-5 text-body-1 grey--text text--darken-3">
            {{ mensajeRechazo }}
          </v-card-text>
          <v-card-actions class="pa-4 pt-0 border-top">
            <v-spacer></v-spacer>
            <v-btn color="error" text rounded @click="motivoRechazo = false" class="px-4">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";

export default {
  name: "MateriaCodigoClaseVideo",
  components: {
    CardIeaAppMain
  },

  filters: {
    formatDate(value) {
      if (!value) return "";
      return moment(value).format("DD/MM/YYYY");
    }
  },

  data: () => ({
    tab: 0,
    hoy: moment(new Date()).format("YYYY-MM-DD"),
    title: "Nuevo trámite",
    tramite: { text: "", value: "" },
    curso: { text: "", value: "" },
    sede: { text: "", value: "" },
    urgencia: { text: "Normal", value: "Normal" },
    select: {},
    urgencias: [
      { text: "Normal", value: "Normal" },
      { text: "Media", value: "Media" },
      { text: "Alta", value: "Alta" }
    ],
    tramites: [],
    cursos: [],
    tramitesUser: [],
    sedes: [],
    person: "",
    personRules: [v => !!v || "Campo obligatorio"],
    motivoRechazo: false,
    mensajeRechazo: "",
    tramitesEmail: [32, 39, 15, 4], // IDs of tramites that will be sent by email
    materias: "",
    tipoExamen: "",
    fechaExamen: "",
    menu: false,
    tiposExamen: [
      { text: "1er Parcial", value: "1er Parcial" },
      { text: "2do Parcial", value: "2do Parcial" },
      { text: "Recuperatorio", value: "Recuperatorio" },
      { text: "Examen Final", value: "Examen Final" }
    ]
  }),

  computed: {
    isValidForm() {
      if (!this.curso || !this.curso.value) return false;
      if (!this.tramite || !this.tramite.value) return false;
      if (!this.person) return false;
      
      if (this.tramite.value === 36) {
        if (!this.materias || !this.tipoExamen || !this.fechaExamen) return false;
      }
      return true;
    }
  },

  methods: {
    getEstadoColor(estado) {
      if (!estado) return "grey lighten-3";
      const e = estado.toLowerCase();
      if (e.includes("cancelado") || e.includes("rechazado")) return "error lighten-5";
      if (e.includes("finalizado") || e.includes("aprobado") || e.includes("resuelto")) return "success lighten-5";
      if (e.includes("proceso") || e.includes("pendiente")) return "warning lighten-5";
      return "grey lighten-4";
    },
    getEstadoTextColor(estado) {
      if (!estado) return "grey";
      const e = estado.toLowerCase();
      if (e.includes("cancelado") || e.includes("rechazado")) return "error";
      if (e.includes("finalizado") || e.includes("aprobado") || e.includes("resuelto")) return "success darken-1";
      if (e.includes("proceso") || e.includes("pendiente")) return "warning darken-2";
      return "grey darken-2";
    },
    async addTramite() {
      let tramite = this.tramite.value;
      let sede = this.sede.value;
      let urgencia = this.urgencia.value;

      let dataSend = {
        process: tramite,
        sede: sede,
        emergency: urgencia,
        person: this.person,
        curso: this.curso.text
      };

      if (tramite === 36) {
        dataSend.materias = this.materias;
        dataSend.tipoExamen = this.tipoExamen;
        dataSend.fechaExamen = this.fechaExamen;
      }

      let url = "alumno-tramite/store";
      await this.$API
        .post({
          url: url,
          data: dataSend
        })
        .then(() => {
          this.loadTramites();
          this.tab = 1; // Switch to Mis Tramites
          
          // Reset form
          this.tramite = { text: "", value: "" };
          this.person = "";
          this.materias = "";
          this.tipoExamen = "";
          this.fechaExamen = "";
        });
    },
    async loadTramites() {
      let url = "alumno-tramites";
      await this.$API
        .get({
          url: url
        })
        .then(res => {
          this.tramitesUser = res;
        });
    },

    motivoRechazoTramite(motivo) {
      this.mensajeRechazo = motivo;
      this.motivoRechazo = true;
    },

    async loadCursos() {
      let url = "alumno/cursos";
      await this.$API
        .get({
          url: url
        })
        .then(res => {
          this.cursos = res
            .filter(curso => curso.curso_data !== null)
            .map(curso => ({
              text: curso.curso_data.Feriado,
              value: curso.curso_data.IDF
            }));
        })
        .catch(err => {
          console.log(err);
        });
    },

    async tramitesReq() {
      this.$API
        .get({
          url: "tramites",
          data: {
            curso: this.curso.text
          }
        })
        .then(res => {
          this.tramites = res;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.loadCursos();
    this.motivoRechazo = false;
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true ||
      this.$store.getters.user.excedente
    ) {
      this.$router.push({
        name: "Home"
      });
    }
    console.log(this.hoy);
    this.idTest = this.$route.params.test;

    this.$API
      .get({
        url: "sedes",
        data: {}
      })
      .then(res => {
        this.sedes = res;
      })
      .catch(err => {
        console.log(err);
      });
    this.$API
      .get({
        url: "alumno-tramites"
      })
      .then(res => {
        this.tramitesUser = res;
      });
  },
  watch: {
    curso: {
      handler() {
        if (!this.curso || !this.curso.text) return;
        this.$API
          .get({
            url: `tramites?curso=${this.curso.text}`
          })
          .then(res => {
            this.tramites = res;
          })
          .catch(err => {
            console.log(err);
          });
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.tramite-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
  padding: 24px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.premium-tabs .v-tab {
  text-transform: none !important;
  letter-spacing: normal !important;
  font-size: 1.05rem !important;
  color: #64748b !important;
  transition: all 0.3s ease;
}
.premium-tabs .v-tab--active {
  color: #1976d2 !important;
}

.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }
.bg-info-light { background-color: #e0f2fe; }
.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.border-none { border: none !important; }
.border-top { border-top: 1px solid rgba(0, 0, 0, 0.05); }

.hover-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.hover-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.15) !important;
}

.shadow-premium {
  box-shadow: 0 8px 20px -6px rgba(25, 118, 210, 0.4) !important;
}

.line-height-1 { line-height: 1.2; }
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
</style>
